module.exports = __webpack_public_path__ + "h5/img/avatar.fd503089.jpg";